import angular from 'angular';
import needALoanModalComponent from './needALoanModal.component';

let needALoanModalModule = angular.module('needALoanModal', [
])

.component('needALoanModal', needALoanModalComponent)

.name;

export default needALoanModalModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/needALoan/needALoanModal/needALoanModal.js